import { render, staticRenderFns } from "./ImprovedTaskSelect.vue?vue&type=template&id=38b12be2&scoped=true"
import script from "./ImprovedTaskSelect.vue?vue&type=script&lang=js"
export * from "./ImprovedTaskSelect.vue?vue&type=script&lang=js"
import style0 from "./ImprovedTaskSelect.vue?vue&type=style&index=0&id=38b12be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b12be2",
  null
  
)

export default component.exports